import App from './HOClevel';

export default App;
